"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnNameFixVisitor = void 0;
const _1 = require(".");
class ColumnNameFixVisitor extends _1.VisitorBase {
    namesMap;
    constructor(namesMap) {
        super();
        this.namesMap = namesMap;
    }
    // this will translate old names to new names
    visitColumn(node) {
        if (node.isPlanVariable())
            return;
        const newColName = this.namesMap.get(node.tokenWithoutDelimiter);
        if (!newColName)
            return;
        const oldName = node.tokenWithoutDelimiter;
        node.tokenWithoutDelimiter = newColName;
        node.token = node.token.replace(oldName, newColName);
        node.translation = node.translation.replace(oldName, newColName);
    }
}
exports.ColumnNameFixVisitor = ColumnNameFixVisitor;
